import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { ShowHide } from "components/layout";
import './Panel.css';

export function Panel(
    {
        id = null,
        color = "",
        selected = false,
        disabled = false,
        onClick = () => { },
        isTab = false,
        children,
        className
    }
) {
    function onPanelClick(){
        if (!disabled) {
            onClick(id);
        }
    }
    function onPanelKeyDown(e) {
        if (e.target !== e.currentTarget) {
            return;
        }
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            onPanelClick();
        }
    }
    return (
        <div className={classNames('box-panel', {"box-panel-selected": selected }, { "panel-disabled bp6-skeleton": disabled }, className)}
            id={id}
            onClick={onPanelClick}
            onKeyDown={onPanelKeyDown}
            role="button"
            tabIndex={-1}>
            <ShowHide evaluator={color}
                show={<div className='box-panel-color-bar' style={{ backgroundColor: color }}></div>} 
            />
            <div className={classNames({'box-panel-content' : !isTab }, {'box-panel-after-color-bar' : color !== ""})}>
                {children}
            </div>
        </div>
    );
}

Panel.propTypes = {
    id: PropTypes.string,
    onClick: PropTypes.func,
    disabled: PropTypes.bool,
    className: PropTypes.string,
    color: PropTypes.string,
    isTab: PropTypes.bool,
    selected: PropTypes.bool
};